exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selfLink-2{margin-left:-10px;color:#fff!important}.selfLink-2 a{padding-left:28px;padding-top:20px;font-size:13px;margin-right:-10px}.off-canvas-sidebar .nav li a,.selfLink-2 a,.sidebar .nav li a{color:#fff!important}", ""]);

// exports
